module.exports = __webpack_public_path__ + "img/DA-HMI-Insurance-Tagging-1.0f7e533d.webp";